import axios from "axios";

let avisoGlobal = null;

export async function cargarAvisoGlobal() {
  try {
    const { data } = await axios.get("/proveedores/getAvisos");
    if (data && data.data && data.data.activo) {
      avisoGlobal = data.data;
    }
  } catch (error) {
    console.error("No se pudo cargar el aviso global", error);
  }
}

export function obtenerAvisoGlobal() {
  return avisoGlobal;
}
